import * as React from "react";

import { Button, Grid, Modal, TextInput, Title } from "@mantine/core";
import {
  addViaEdge,
  addViaGroup,
  BaseEdgeDataType,
  BaseNodeDataType,
  createNode,
  workflowActionTypes,
  workflowStateType,
} from "../WorkflowUtils";
import { IDispatchAction } from "src/types";
import { UAction, UNodeType, UseCaseType } from "@supportinitiative/common";
import { showNotification } from "@mantine/notifications";
import { getId, getIsStringMatch } from "../../../utilities";
import { UseFieldArrayReturn } from "react-hook-form";

export default function AddViaGroup({
  name,
  node,
  workflowDispatch,
  nodes,
  edges,
  actions,
  options,
  fromOrchestrator,
  setValue,
}: {
  name: string;
  node: BaseNodeDataType | null;
  workflowDispatch: React.Dispatch<IDispatchAction<workflowActionTypes, workflowStateType>>;
  nodes: BaseNodeDataType[];
  edges: BaseEdgeDataType[];
  actions: UAction[];
  options: { label: string; name: string; icon: React.ReactNode }[];
  fromOrchestrator?: boolean;
  setValue: (key: string, value: any) => void;
}) {
  let [filteredOptions, setFilteredOptions] = React.useState(options);

  return (
    <Modal
      centered
      size={"xl"}
      opened={true}
      onClose={() => {
        workflowDispatch({
          type: "RESET",
          value: {
            action: null,
            via: null,
          },
        });
      }}
      title={<Title order={3}>Add</Title>}
    >
      <Grid align="stretch" gutter={"xs"} mb="xs">
        <Grid.Col span={12}>
          <TextInput
            placeholder="Filter"
            onChange={(event) => {
              if (event.target.value) {
                let values = options.filter(getIsStringMatch(event.target.value));
                setFilteredOptions(values);
              } else {
                setFilteredOptions(options);
              }
            }}
          />
        </Grid.Col>
      </Grid>

      <Grid align="center" gutter={"xs"} mt="lg" mb="xs">
        {filteredOptions.map((option) => {
          return (
            <Grid.Col span={3} key={option.name}>
              <Button
                leftSection={option.icon}
                fullWidth
                variant="default"
                onClick={() => {
                  const newNode = createNode(getId(), option.name as UNodeType, option.name, node?.id);
                  if (node) {
                    const newWorkflow = addViaGroup(newNode, node, nodes, edges, actions);
                    // console.log("addViaGroup newWorkflow", newWorkflow);
                    setValue(name, newWorkflow);
                    workflowDispatch({
                      type: "RESET",
                      value: {
                        action: null,
                        via: null,
                      },
                    });
                  }
                }}
              >
                {option.label}
              </Button>
            </Grid.Col>
          );
        })}
      </Grid>
    </Modal>
  );
}
